import React from 'react';
import { TextInput, TextArea, CardList, SectionHeader, Field } from './Fields';
import ImageUpload from './ImageUpload';

const COLORS = ['blue', 'emerald', 'violet', 'orange', 'red', 'yellow'];

const CasosSucessoEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Seção Casos de Sucesso" />
      <TextInput label="Título" value={data.heading} onChange={v => set('heading', v)} />
      <TextArea label="Subtítulo" value={data.subheading} onChange={v => set('subheading', v)} />

      <div className="mt-4">
        <CardList
          label="Casos (pins no mapa)"
          value={data.cases}
          onChange={v => set('cases', v)}
          emptyCard={{ title: '', description: '', color: 'blue', lat: null, lng: null }}
          renderCard={(item, i, update) => (
            <div className="space-y-2">
              <TextInput label="Nome da organização" value={item.title} onChange={v => update({ title: v })} />
              <TextArea label="Descrição" value={item.description} onChange={v => update({ description: v })} rows={2} />
              <div className="grid grid-cols-2 gap-2">
                <Field label="Latitude" hint="Ex: -5.09 (Teresina)">
                  <input
                    type="number"
                    step="0.0001"
                    value={item.lat ?? ''}
                    onChange={e => update({ lat: e.target.value ? parseFloat(e.target.value) : null })}
                    placeholder="-5.09"
                    className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </Field>
                <Field label="Longitude" hint="Ex: -42.81 (Teresina)">
                  <input
                    type="number"
                    step="0.0001"
                    value={item.lng ?? ''}
                    onChange={e => update({ lng: e.target.value ? parseFloat(e.target.value) : null })}
                    placeholder="-42.81"
                    className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </Field>
              </div>
              <p className="text-xs text-gray-400 -mt-1">
                Busque "{item.title || 'cidade'} coordenadas" no Google Maps para obter lat/lng
              </p>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Cor do pin</label>
                <div className="flex gap-2 flex-wrap">
                  {COLORS.map(c => (
                    <button key={c} onClick={() => update({ color: c })}
                      className={`px-3 py-1 rounded-full text-xs font-semibold border-2 transition-all bg-${c}-100 text-${c}-700 ${item.color === c ? 'border-blue-500 scale-110' : 'border-transparent opacity-60'}`}>
                      {c}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default CasosSucessoEditor;
